import React from 'react';

import Spin from 'antd/es/spin';
import Empty from 'antd/es/empty';

import ColumChart from '@ant-design/charts/es/column';

import { formatDate } from 'helpers/date';
import { timeFormat } from 'config/common';

const defaultStyles = {
  width: '100%',
};

// Example data
// const data = [
//   {
//     time: '2023-03-21T09:40:00.000Z',
//     ratio: 0.7,
//     color: '#42B0D5',
//   },
//   {
//     time: '2023-03-21T09:50:00.000Z',
//     ratio: 0.8,
//     color: '#42B0D5',
//   },
//   {
//     time: '2023-03-21T10:00:00.000Z',
//     ratio: 0.9,
//     color: '#42B0D5',
//   },
//   {
//     time: '2023-03-21T10:10:00.000Z',
//     ratio: 0.6,
//     color: '#42B0D5',
//   },
//   {
//     time: '2023-03-21T10:20:00.000Z',
//     ratio: 0.5,
//     color: '#42B0D5',
//   },
//   {
//     time: '2023-03-21T10:30:00.000Z',
//     ratio: 0.2,
//     color: '#42B0D5',
//   },
//   {
//     time: '2023-03-21T10:40:00.000Z',
//     ratio: -0.1,
//     color: '#2F54EB',
//   },
//   {
//     time: '2023-03-21T10:50:00.000Z',
//     ratio: -0.2,
//     color: '#2F54EB',
//   },
//   {
//     time: '2023-03-21T11:00:00.000Z',
//     ratio: -0.4,
//     color: '#2F54EB',
//   },
//   {
//     time: '2023-03-21T11:10:00.000Z',
//     ratio: -0.6,
//     color: '#2F54EB',
//   },
//   {
//     time: '2023-03-21T11:20:00.000Z',
//     ratio: -0.5,
//     color: '#2F54EB',
//   },
//   {
//     time: '2023-03-21T11:30:00.000Z',
//     ratio: -0.2,
//     color: '#2F54EB',
//   }
// ];

const FlowRatioChart = ({ isLoading = false, data, style = {}, config = {} }) => {
  if (isLoading) {
    return <Spin
      size={'default'}
      style={{ width: '100%', padding: '36px' }}
    />
  }

  if (!data.length) {
    return <Empty
      description="No stats"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '200px',
      }}
      imageStyle={{ display: 'none' }}
    />
  }

  style = Object.assign({}, defaultStyles, style);

  config = Object.assign({}, config, {
    renderer: 'svg',
    title: {
      visible: false,
    },
    description : {
      visible : false,
    },
    xAxis: {
      formatter: (value) => {
        return formatDate(new Date(value), timeFormat);
      },
      line: {
        visible: false,
      },
      title: {
        visible: false,
      },
    },
    yAxis: {
      nice: true,
      min: -1,
      max: 1,
      tickCount: 5,
      position: 'right',
      title: {
        visible: false,
      },
      label: {
        fill: '#232526'
      },
      offsetX: 20,
    },
    guideLine: [
      {
        type: 'mean', // 'max' | 'min' | 'median' |  'mean',
        start: ['0%', '50%'],
        end: ['100%', '50%'],
        lineStyle: {
          stroke: '#52C41A',
          lineDash: [4, 4],
          lineWidth: 4,
        },
      },
    ],
    xField: 'time',
    yField: 'ratio',
    columnStyle: (_, yValue) => {
      return {
        fill: yValue >= 0 ? '#42B0D5' : '#2F54EB',
      };
    },

    // interactions: [
    //   {
    //     type: 'slider',
    //     cfg: {
    //       start: 0.4,
    //       end: 0.45,
    //     },
    //   },
    // ]
  });

  return (
    <ColumChart style={style} data={data} {...config} />
  );
};

export default FlowRatioChart;